import { Component, ChangeDetectionStrategy, Input, input } from '@angular/core';
import { Observable } from 'rxjs';
import { SocialChannel } from '../../models';
import { IconComponent } from '@teamfoster/sdk/icon';
import { SocialIconPipe } from '../../pipes/social-icon.pipe';
import { TrackLinkClickDirective } from 'src/app/shared';

@Component({
  selector: 'app-social-channel-buttons',
  templateUrl: './social-channel-buttons.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  styleUrls: ['./social-channel-buttons.component.scss'],
  imports: [IconComponent, SocialIconPipe, TrackLinkClickDirective],
})
export class SocialChannelButtonsComponent {
  channels = input.required<SocialChannel[]>();
  context = input<string>('social-channel-button');
}
